import { createConfig, lazyRoute } from "../config/config-utils"
import { WHEN } from "../config/constants"

const CoreBookmarksApp = lazyRoute(
  ()=> import("./CoreBookmarksApp"),
  "CoreBookmarksApp",
)

export const CORE_BOOKMARKS_CONFIG = createConfig({
  component: CoreBookmarksApp,
  key: "core-bookmarks",
  label: "Core Bookmarks",
  when: WHEN,
})
